import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  "https://woeexpeqouhtojnuyueg.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndvZWV4cGVxb3VodG9qbnV5dWVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDcwNTY0MzcsImV4cCI6MjAyMjYzMjQzN30.nreTdyMMF6nP0oiZkpLN-MP5P0tV4roDMDBeHZ_va2Y"
);

export const getConfigService = async (product, site_uuid) => {
  const { data } = await supabase
    .from(`site_${product}_config`)
    .select()
    .eq("site_uuid", site_uuid)
    .order("id");
  return await data;
};

export const setConfigService = async (product, payload) => {
  const { data } = await supabase
    .from(`site_${product}_config`)
    .insert(payload);
  return await data;
};

export const updateConfigService = async (product, payload) => {
  const { data } = await supabase
    .from(`site_${product}_config`)
    .update(payload)
    .eq("site_uuid", payload.site_uuid);
  return await data;
};
